import { render, staticRenderFns } from "./chatroomexamine.vue?vue&type=template&id=53e56f15&"
import script from "./chatroomexamine.vue?vue&type=script&lang=js&"
export * from "./chatroomexamine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports